import vacancy_video_base from './base/default';
import vacancy_video_groups from './groups/index';

export default [
  {
    path: 'base',
    component: vacancy_video_base,
    name: 'vacancy_video_base',
    pathToRegexpOptions: { strict: true },
    props: route => ({
      vacancyId: route.params.id
    }),
    meta: {
      title: 'pageTitles.routes.vacancies.editVideoInterview'
    }
  },
  {
    path: 'groups',
    component: vacancy_video_groups,
    name: 'vacancy_video_groups',
    props: route => ({
      vacancyId: route.params.id
    }),
    meta: {
      title: 'vacancy.videoInterview.tabs.groups'
    }
  }
];
